module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQBAMAAAACH4lsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTB4iKSAgJx8iKSAjKB4jKCAgKCAkKB8jKB4iKR0jJh8jKWVgJs8AAAALdFJOUwCIEN9foiBAv3BQRv0GZgAAAFJJREFUCNdjYEAARiEYS3orlMG0e/cECItt924juJgBVLp7dwKUVb1bAGbK7i0wzda7GVIXgJnJW1ytN0LMKdkNM4kDyNoEUeq8G67fNQTJSQwAgn0XDdKI93EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/call1.png
// module id = 9d+P
// module chunks = 1